<template>
  <popover-box ref="popover" :parent="parent" :direction="direction" :colorTheme="colorTheme">
    <template v-for="n in notifications">
      <notification :key="n.id"
        :notification="n"
        :actionEngine="actionEngine"
        :dismiss="dismiss"
        @delete="deleteNotification"
      />
    </template>
  </popover-box>
</template>

<script>
import PopoverBox from './PopoverBox'
import popoverContainerMixin from './popoverContainerMixin'
import Notification from '../../notifications'
// TODO will add in scrolling into the component when needed.

export default {
  components: {
    PopoverBox,
    Notification
  },
  mixins: [popoverContainerMixin],
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    actionEngine: Object,
    deleteNotificationFunc: Function,
    maxHeight: {
      type: Number,
      default: 500
    },
    maxWidth: {
      type: Number,
      default: 500
    },
    colorTheme: {
      type: String,
      default: undefined
    }
  },
  methods: {
    deleteNotification (notification) {
      this.deleteNotificationFunc(notification)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// NotificationPopover.vue?41506b66